import apiClient from '../client'
import type { PageResponse } from '../types'
import type {
  MunicipalityResponse,
  MunicipalityCreateRequest,
  MunicipalityUpdateRequest,
  MunicipalityOcrMappingUpdateRequest,
  OcrCaseApprovalResponse,
  OcrCaseFieldValueResponse,
  OcrCaseFieldValueUpdateRequest,
  OcrSystemKeyCatalogResponse,
  PublicMunicipalityResponse,
} from './types'

export const municipalitiesApi = {
  list() {
    return apiClient.get<MunicipalityResponse[]>('/api/municipalities')
  },

  search(params?: {
    code?: string
    name?: string
    prefecture?: string
    status?: string
    ocrUse?: boolean
    sortBy?: string
    order?: 'ASC' | 'DESC'
    page?: number
    size?: number
  }) {
    return apiClient.get<PageResponse<MunicipalityResponse>>('/api/municipalities/search', { params })
  },

  getById(id: number) {
    return apiClient.get<MunicipalityResponse>(`/api/municipalities/${id}`)
  },

  create(data: MunicipalityCreateRequest) {
    return apiClient.post<MunicipalityResponse>('/api/municipalities', data, { _suppressToastOnFieldErrors: true })
  },

  update(id: number, data: MunicipalityUpdateRequest) {
    return apiClient.put<MunicipalityResponse>(`/api/municipalities/${id}`, data, { _suppressToastOnFieldErrors: true })
  },

  updateOcrMapping(id: number, data: MunicipalityOcrMappingUpdateRequest) {
    return apiClient.put<MunicipalityResponse>(`/api/municipalities/${id}/ocr-mapping`, data)
  },

  systemKeyCatalog() {
    return apiClient.get<OcrSystemKeyCatalogResponse[]>('/api/municipalities/system-key-catalog')
  },

  /**
   * ログイン前ヘッダ表示用。subdomain → 自治体名解決の公開エンドポイント。
   * 該当なしは 404 を返すので呼び出し側で握り潰す想定（{ _silent: true }）。
   */
  publicGetBySubdomain(subdomain: string) {
    return apiClient.get<PublicMunicipalityResponse>(
      `/api/public/municipalities/by-subdomain/${encodeURIComponent(subdomain)}`,
      { _silent: true },
    )
  },
}

export const ocrCaseFieldValuesApi = {
  list(caseId: number) {
    return apiClient.get<OcrCaseFieldValueResponse[]>(`/api/ocr-cases/${caseId}/field-values`)
  },

  update(caseId: number, updates: OcrCaseFieldValueUpdateRequest[]) {
    return apiClient.put<OcrCaseFieldValueResponse[]>(`/api/ocr-cases/${caseId}/field-values`, updates)
  },

  approve(caseId: number) {
    return apiClient.post<OcrCaseApprovalResponse>(`/api/ocr-cases/${caseId}/approve`)
  },

  downloadPdf(caseId: number) {
    return apiClient.get(`/api/ocr-cases/${caseId}/pdf`, { responseType: 'blob' })
  },
}
